import { Error } from "@/components/admin/error";
import { TaskNudges } from "./TaskNudges";
import { useRoleRefresh } from "./useRoleRefresh";
import { logClientError, useErrorLog } from "./useErrorLog";
import { ViewAsBanner } from "./ViewAs";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileNavigation } from "./MobileNavigation";
import { PullToRefresh } from "./PullToRefresh";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  useRoleRefresh();
  useErrorLog();
  return (
    <DataImportProvider>
      <PullToRefresh />
      <ViewAsBanner />
      <ErrorBoundary
        FallbackComponent={Error}
        onError={(error) =>
          logClientError(String((error as Error)?.message ?? error), {
            stack: (error as Error)?.stack?.slice(0, 1500),
            boundary: true,
          })
        }
      >
        <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
          {children}
        </Suspense>
      </ErrorBoundary>
      <MobileNavigation />
      <Notification mobileOffset={{ bottom: "72px" }} />
      <TaskNudges />
    </DataImportProvider>
  );
};
